import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { ActionIcon } from "@mantine/core";
import type { ActionIconProps } from "@mantine/core";
import styled from "styled-components";
import { theme } from "../../../theme";

const TableDownloadButton = ({ onClick }: any) => {
  return (
    <div onClick={onClick}>
      <StyledActionIcon radius={50} size={40}>
        <ArrowDownTrayIcon color={theme.colors.greyscale.black} height={24} />
      </StyledActionIcon>
    </div>
  );
};
export default TableDownloadButton;

const StyledActionIcon = styled(ActionIcon)<ActionIconProps>`
  background: transparent;
  &:hover {
    background: ${theme.colors.greyscale.gray20};
  }
`;
